export default {
    getPostsWithLocation : (state) => {
        return state
    }
};
